import styled from 'styled-components';
import { DatePicker as AntdDatePicker } from 'antd';
import { BorderedField } from './Flex';


const StyledDatePicker = styled(AntdDatePicker).attrs({
    autoFocus: false,
    bordered: false,
    suffixIcon: null,
    allowClear: false,
    placeholder: null,
    format: "DD-MMM-YYYY",
})`
    width: 100%;
    padding: 0;

    & input {
        text-align: center;
        color: var(--sp-label-color);
        font-weight: 600;
        font-size: 13px;
    }
`;

const StyledRangePicker = styled(AntdDatePicker.RangePicker).attrs({
    autoFocus: false,
    bordered: false,
    suffixIcon: null,
    allowClear: false,
    placeholder: null,
    format: "DD-MMM-YYYY"
})`
    width: 100%;
    padding: 0;

    & input {
        text-align: center;
        color: var(--sp-label-color);
        font-weight: 600;
        font-size: 13px;
    }
`;

const DatePicker = (props) => (
    <BorderedField padding={{ left: "11px", right: "11px" }} borderWidth="1px">
        <StyledDatePicker {...props} />
    </BorderedField>
);

DatePicker.RangePicker = (props) => (
    <BorderedField padding={{ left: "11px", right: "11px" }} borderWidth="1px">
        <StyledRangePicker {...props} />
    </BorderedField>
);

export { DatePicker };
